var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"allstops"}},[_c('big-top',{attrs:{"title":"All Stops","smalltitle":"Perennial Garden"}}),_vm._v(" "),_c('stops',{attrs:{"exhibit-group":"perennial"}}),_vm._v(" "),_c('bottom-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }